import { render, staticRenderFns } from "./Lc.vue?vue&type=template&id=0ef61812"
import script from "./Lc.vue?vue&type=script&lang=js"
export * from "./Lc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports